




























































import Vue from 'vue'
import { Post, User, CommentId, Comment } from 'types'
import { Component, Prop } from 'vue-property-decorator'
import BaseIcon from 'vuecomponents/base_icon.vue'
import { namespace, Getter } from 'vuex-class'
import IntlMixin from 'vuemixins/intl_mixin'
import SurfacePostComment from 'vuecomponents/SurfacePostComment.vue'
import MultilineInput from 'vuecomponents/multiline_input.vue'
import AvatarImage from 'vuecomponents/avatar_image.vue'
import OzButton from 'library/v4/components/oz-button.vue'

const commentModule = namespace('comment')
const browser = namespace('browser')

@Component({
  components: {
    AvatarImage,
    BaseIcon,
    SurfacePostComment,
    MultilineInput,
    OzButton,
  },
  mixins: [IntlMixin],
})
export default class SurfacePostComments extends Vue {
  isAddCommentFocused = false

  @Getter colorScheme!: 'light' | 'dark'

  @Prop({ default: null }) post!: Post
  @Prop({ default: null }) user!: User
  @Prop({ default: null }) commentIds!: CommentId[]
  @Prop({ default: null }) comments!: { [id: number]: Comment }
  @Prop({ default: false }) isCommentable!: boolean
  @Prop({ default: null }) commentBeingEditedId!: CommentId

  @Getter isStream!: boolean

  @commentModule.Getter newCommentBodyForPostCid
  @commentModule.Action startWritingNewComment
  @commentModule.Action stopWritingNewComment
  @commentModule.Action updateNewCommentBody

  @browser.Getter isPhone!: boolean

  get commentsList(): Comment[] {
    return this.commentIds.map((id) => this.comments[id])
  }

  get newCommentBody(): string {
    return this.newCommentBodyForPostCid(this.post.cid)
  }

  stopEditingComment(): void {
    this.$emit('stop-editing')
  }

  editComment($event): void {
    this.$emit('edit', $event)
  }

  publishComment(): void {
    if (!this.newCommentBody) return

    this.$emit('create', {
      postId: this.post.id,
      body: this.newCommentBody,
    })
    this.updateNewCommentBody({ postCid: this.post.cid, body: '' })
    const vueInputElement = this.$refs.addCommentInput as MultilineInput
    vueInputElement.focus()
  }

  submit(): void {
    this.publishComment()
  }

  onAddCommentFocus(): void {
    this.isAddCommentFocused = true
    this.startWritingNewComment({ postId: this.post.id })
  }

  onAddCommentBlur(): void {
    this.isAddCommentFocused = false
    if (!this.isPhone) {
      // in mobile screen size, the add comment text field acts a "button" to open the add comment modal
      // we don't need to stop editing when the text input lose focus
      this.stopWritingNewComment({ postId: this.post.id })
    }
  }

  onAddCommentInput(body): void {
    this.updateNewCommentBody({ postCid: this.post.cid, body })
  }

  onAddCommentSubmitClicked(): void {
    this.publishComment()
  }
}
